export default __webpack_public_path__ + "static/media/activity-pink-16px.45df1df3.svg";